import { PLPPages } from '@/app/(plp)/types'

export const PRODUCT_QUERY_PARAMS = {
    PAGE_NUMBER: 'page_number',
    PAGE_SIZE: 'page_size',
    COLOR: 'color',
    PRICE_FROM: 'from_price',
    PRICE_TO: 'to_price',
    HAS_STOCK: 'has_stock',
    BRAND: 'brand',
    DYNAMIC_FACET: 'facet',
    CATEGORY: 'cat',
    SORT_BY: 'sort',
    SEARCH: 'query',
}

export const PLP_PAGES_WITH_BREADCRUMB = [
    PLPPages.Categories,
    PLPPages.Combination,
    PLPPages.BrandCategoriesCombination,
]
